/**
 * OptionsCommand — Sprint 21.11 Domain Command Center for JANUS.
 *
 * Per ADR-027, every specialist ships with its Command Center. JANUS's
 * is /command/options. Previously the /options route was a stub; this
 * sprint activates it by registering the `options` domain with
 * CommandCenterLayout, which fetches /api/command/options/overview and
 * renders the standard set of blocks (summary strip, KAIROS framing,
 * signals, exposure, catalysts, theme exposure, recent alerts) PLUS
 * the domain-specific `volatility_context` block (VolatilityRegimeBlock
 * in CommandCenterLayout).
 *
 * The options domain is market-level (ticker-agnostic) — ticker-scoped
 * blocks render empty, but that's expected; the Volatility Regime card
 * carries the substance.
 */
import { useEffect } from 'react';
import { Activity } from 'lucide-react';
import CommandCenterLayout from '../../components/CommandCenter/CommandCenterLayout.jsx';
import OptionsStrategyPanel from '../../components/options/OptionsStrategyPanel.jsx';
import { usePage } from '../../contexts/PageContext.jsx';

export default function OptionsCommand() {
  const { setPage } = usePage();
  useEffect(() => { setPage('command-options'); }, []);
  return (
    <div className="space-y-4">
      <CommandCenterLayout
        domain="options"
        title="Options & Volatility"
        icon={<Activity className="w-5 h-5" />}
        subtitle="JANUS · VIX term structure · vol regime · cross-regime divergences"
      />
      {/* Sprint 22.7.29: thesis-to-trade + education spec engine, below the JANUS vol view */}
      <OptionsStrategyPanel />
    </div>
  );
}
